import { Observable } from 'rxjs';
import { CreateSocioUseCase } from '../use-case/socio/createSocio.useCase';
import { Create } from '../../domain/repositories/general/create.interface';
import { Update } from '../../domain/repositories/general/update.interface';
import { Delete } from '../../domain/repositories/general/delete.interface';
import { Retrieve } from '../../domain/repositories/general/retrieve.interface';
import { UpdateSocioUseCase } from '../use-case/socio/updateSocio.useCase';
import { DeleteSocioUseCase } from '../use-case/socio/deleteSocio.useCase';
import { RetrieveSocioUseCase } from '../use-case/socio/retrieveSocio.useCase';
import { Socio } from '../../domain/models/socio.model';

/**
 *Manejador general de las operaciones CRUD
 *
 * @export
 * @class SocioManager
 * @implements {Create}
 * @implements {Update}
 * @implements {Delete}
 * @implements {Retrieve}
 */
export class SocioManager implements Create, Update, Delete, Retrieve {
  constructor(
    private createSocioUseCase: CreateSocioUseCase,
    private updateSocioUseCase: UpdateSocioUseCase,
    private deleteSocioUseCase: DeleteSocioUseCase,
    private retrieveSocioUseCase: RetrieveSocioUseCase
  ) {}

  public create(employee: Socio): Observable<Socio> {

    return this.createSocioUseCase.create(employee);
  }

  public delete(id: number): Observable<boolean> {

    return this.deleteSocioUseCase.delete(id);
  }

  public get(id: number): Observable<Socio> {

    return this.retrieveSocioUseCase.get(id);
  }

  public getAll(): Observable<Socio[]> {

    return this.retrieveSocioUseCase.getAll();
  }

  public update(id: number, employee: Socio): Observable<Socio> {
    
    return this.updateSocioUseCase.update(id, employee);
  }
}
